import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminModal } from "@/components/pageSettings/AdminModal";

function who(c) {
  const w = c.changed_by || {};
  let s = w.name || w.email || "Someone";
  if (w.email && w.name) s += ` (${w.email})`;
  if (w.role) s += ` · ${w.role.replace(/_/g, " ")}`;
  if (w.impersonated_by) s += ` · logged in as them by ${w.impersonated_by}`;
  return s;
}

function emailNote(c) {
  if (c.email_skipped) return "Not emailed (test or sample buyer)";
  return c.emailed ? `Emailed ${c.emailed} ${c.emailed === 1 ? "person" : "people"}` : "Email pending or not sent";
}

function buyerEmailNote(c) {
  if (c.buyer_email === "sent") return `Buyer emailed at ${c.buyer_email_to}`;
  if (c.buyer_email === "failed") return "Buyer email failed to send";
  if (c.buyer_email === "skipped") return "Buyer email skipped (test buyer or no contact email)";
  return null;
}

function ChangeRow({ c }) {
  return (
    <li className="border-2 border-black p-2.5 text-[11px]" data-testid={`buyer-history-item-${c.id}`}>
      <div className="flex flex-wrap items-baseline gap-2">
        <strong className="uppercase tracking-widest text-[10px]">{c.label}</strong>
        <span className="font-mono text-[10px] text-zinc-500">{new Date(c.at).toLocaleString()}</span>
      </div>
      <div className="mt-1 grid gap-1 sm:grid-cols-2">
        <div><span className="label-mono text-zinc-500">Before</span> {c.before || "—"}</div>
        <div><span className="label-mono text-zinc-500">After</span> {c.after || "—"}</div>
      </div>
      <div className="mt-1 text-zinc-600" data-testid={`buyer-history-who-${c.id}`}>By {who(c)}</div>
      <div className="text-[10px] text-zinc-500">{emailNote(c)}</div>
      {buyerEmailNote(c) && (
        <div className="text-[10px] text-zinc-700" data-testid={`buyer-history-buyer-email-${c.id}`}>
          {buyerEmailNote(c)}{c.buyer_note ? ` · Note: ${c.buyer_note}` : ""}
        </div>
      )}
    </li>
  );
}

// One buyer's past changes: states, pages and lead rules, newest first.
export function BuyerHistoryDialog({ pageId, firm, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/buyer-changes", { params: { page_id: pageId, limit: 200 } })
      .then((r) => setRows(r.data.changes || []))
      .catch(() => setRows(false));
  }, [pageId]);
  return (
    <AdminModal eyebrow="Change history" title={firm} onClose={onClose} testId="buyer-history-modal">
      {rows === null && <div className="text-xs text-zinc-500" data-testid="buyer-history-loading">Loading…</div>}
      {rows === false && <div className="text-xs text-red-700" data-testid="buyer-history-error">Couldn&apos;t load the history. Close this and try again.</div>}
      {rows?.length === 0 && (
        <div className="text-xs text-zinc-600" data-testid="buyer-history-empty">
          No changes yet. Changes to their states, pages and lead rules will show here.
        </div>
      )}
      {rows?.length > 0 && (
        <ul className="space-y-2" data-testid="buyer-history-list">
          {rows.map((c) => <ChangeRow key={c.id} c={c} />)}
        </ul>
      )}
    </AdminModal>
  );
}
